import { render, staticRenderFns } from "./coperarkmantransferrezaktarim.vue?vue&type=template&id=041efab7&"
import script from "./coperarkmantransferrezaktarim.vue?vue&type=script&lang=js&"
export * from "./coperarkmantransferrezaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports